var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-admin-tasks')
}
var staticRenderFns = []

export { render, staticRenderFns }